<input [checked]="element._get('checked')" type="radio" [disabled]="element._get('readOnly')" [name]="element._get('groupName')">
{{element._get('text')}}